import React from 'react'

import './BackgroundVideo.css'
import ALink from './ALink'

const BackgroundVideo = ({
  poster,
  videoTitle,
  children,
  content,
  videoContent,
  videoText,
  slug,
  text
}) => {
  return (
    <div className={`BackgroundVideo`}>
      <video
        poster={poster}
        className={`BackgroundVideo--video`}
        playsInline
        autoPlay
        muted
        loop
        preload="auto"
      >
        {children}
      </video>
      {videoTitle && (
        <div className="BackgroundVideo--videoTitle">
          <div className="BackgroundVideo--Content">
            <header>
              <h3>{videoTitle}</h3>
            </header>
            <p>{videoContent}</p>
          </div>
          <ALink text={videoText} slug="/" />
        </div>
      )}
    </div>
  )
}

export default BackgroundVideo
